export default __webpack_public_path__ + "static/media/no-orders.4f43124c.png";